var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bgitem",class:_vm.isStorm ? 'storm' : 'nostorm',style:({top:_vm.y+'px',left:_vm.x+'px',width:_vm.width+'px',height:_vm.height+'px'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }